import { Activity, Clock, Trash2, Database } from 'lucide-react';

export default function StatCards({ trials = [], enquiries = [] }) {
  const totalLeads = enquiries.length;
  const activeTrials = trials.filter(t => t.status === 'active').length;
  const pendingTrials = trials.filter(t => t.status === 'pending').length;

  // Naive stat for storage reclaimed today (assumes all terminated today)
  const terminated = trials.filter(t => t.status === 'terminated').length;

  return (
    <div className="grid md:grid-cols-4 gap-6 mb-8">
      <div className="bg-white dark:bg-[#1e2336] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-slate-500 dark:text-slate-400 font-medium">Total Leads</h3>
          <Activity className="text-primary-500" size={20} />
        </div>
        <p className="text-3xl font-display font-bold text-slate-900 dark:text-white">{totalLeads}</p>
      </div>

      <div className="bg-white dark:bg-[#1e2336] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-slate-500 dark:text-slate-400 font-medium">Active Trials</h3>
          <Activity className="text-emerald-500" size={20} />
        </div>
        <p className="text-3xl font-display font-bold text-slate-900 dark:text-white">{activeTrials}</p>
      </div>

      <div className="bg-white dark:bg-[#1e2336] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-slate-500 dark:text-slate-400 font-medium">Pending Trial Requests</h3>
          <Clock className="text-amber-500" size={20} />
        </div>
        <p className="text-3xl font-display font-bold text-slate-900 dark:text-white">{pendingTrials}</p>
      </div>

      <div className="bg-white dark:bg-[#1e2336] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-slate-500 dark:text-slate-400 font-medium">Terminated</h3>
          <Database className="text-slate-400" size={20} />
        </div>
        <p className="text-3xl font-display font-bold text-slate-900 dark:text-white">{terminated}</p>
      </div>
    </div>
  );
}
